import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../images/Logo.png';
import Sidebar from './Sidebar'; // Assuming Sidebar component is imported here

const Navbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: 'black', // Changed to primary color
          color: 'common.white', // White text/icons for better contrast
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          height: 80, // Increased height
          justifyContent: 'center', // Vertically center content
        }}
      >
        <Toolbar
          sx={{
            minHeight: '80px !important', // Force toolbar height
            padding: '0 24px', // Add horizontal padding
          }}
        >
          {/* Menu Button */}
          <IconButton
            edge="start"
            color="inherit"
            onClick={toggleSidebar} // Toggle sidebar visibility
            size="large" // Larger button
            sx={{
              mr: 2,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)', // Lighter hover
              },
            }}
          >
            <MenuIcon fontSize="large" /> {/* Larger icon */}
          </IconButton>

          {/* Centered Logo */}
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={Logo}
              alt="ScooterLab Logo"
              style={{
                height: '60px',
                width: '238px', // Set explicit width based on aspect ratio (970/245 * 60)
                objectFit: 'contain', // Ensure the image scales down to fit within the dimensions while maintaining aspect ratio
                imageRendering: 'auto', // Explicitly set to auto
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>

      {/* Sidebar Component */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
    </>
  );
};

export default Navbar;
